import React from "react";

const holder = {
  closeFiltersDropdown(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeFiltersDropdown)
    }
  }
};


export default {
  'TagsDropdown.Wrapper': async ({ isOpen, containerRef, inputRef }, _, internalStateSetter) => {
    if (isOpen) {
      return;
    }

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }


    await internalStateSetter({ isOpen: true, pageNumber: 1 });
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    newInputRef?.current?.children?.[0].focus();
    document.addEventListener("mousedown", holder.closeFiltersDropdown);
  },
  'TagsDropdown.Wrapper.HeaderWrapper.Icon': ({ }, _, internalStateSetter) => {
    internalStateSetter({ isOpen: false });
    document.removeEventListener("mousedown", holder.closeFiltersDropdown);
  },
  'TagsDropdown.Wrapper.HeaderWrapper.Search.Input': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchVal: value });
  },
  'TagsDropdown.Wrapper.BodyWrapper.Body.Row': ({ entry, selectedIds, noTagIds, makeReadyCategory }, outlet) => {
    if (selectedIds.includes(entry.id)) {
      outlet({ selectedIds: selectedIds.filter(id => id !== entry.id), noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
    } else {
      outlet({ selectedIds: [...selectedIds, entry.id], noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
    }
  },
  'TagsDropdown.Wrapper.ButtonsWrapper.ButtonsWrapper.ButtonsWrapper.Button': ({ selectedId, selectedIds, noTagIds, makeReadyCategory }, outlet) => {
    outlet({ selectedIds: selectedIds.filter(id => id !== selectedId), noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
  },
  'TagsDropdown.Wrapper.ClearAllHeader.ClearAll': ({ selectedIds, entries, noTagIds, makeReadyCategory }, outlet) => {
    let currentSelectedIds = selectedIds.filter(id => entries.map(e => e.id).includes(id));
    if (currentSelectedIds.length > 0) {
      outlet({ selectedIds: selectedIds.filter(id => !currentSelectedIds.includes(id)), noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
    } else {
      outlet({ selectedIds: [...selectedIds, ...entries.map(e => e.id)], noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
    }
  },
  'TagsDropdown.Wrapper.BodyWrapper.Body.LoadMore': ({ pageNumber }, _, internalStateSetter) => {
    internalStateSetter({ pageNumber: pageNumber + 1 })
  },
  'TagsDropdown.Wrapper.BodyWrapper.Body.NoTag': async ({ noTagIds, makeReadyCategory, selectedIds, entries }, outlet, internalStateSetter) => {
    let currentSelectedIds = selectedIds.filter(id => entries.map(e => e.id).includes(id));
    if (noTagIds.includes(makeReadyCategory.id)) {
      outlet({ selectedIds: selectedIds.filter(id => !currentSelectedIds.includes(id)), noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
    } else {
      outlet({ selectedIds: selectedIds.filter(id => !currentSelectedIds.includes(id)), noTagIds: [...(noTagIds ?? []), makeReadyCategory.id] });
    }
    await internalStateSetter({ isOpen: false, pageNumber: 1, searchVal: '' });
  },
  'TagsDropdown.Wrapper.ButtonsWrapper.ButtonsWrapper.ButtonsWrapper.NoTag': ({ noTagIds, makeReadyCategory, selectedIds, entries }, outlet, internalStateSetter) => {
    let currentSelectedIds = selectedIds.filter(id => entries.map(e => e.id).includes(id));
    outlet({ selectedIds: selectedIds.filter(id => !currentSelectedIds.includes(id)), noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
  }
};
